export const ALL_OWNER_VALUE = 'all';
export const ME_OWNER_VALUE = '__hs__ME';
export const NONE_OWNER_VALUE = '';